import { over } from "lodash";
import { z, ZodType } from "zod";
import { AircraftType } from "../../../globals/interfaces";
import { dateString, nullableNumber, numericString, optional, ZodEntriesOf } from "../../../utils";

export const AircraftTypeSchema = z.object({
    id: optional(z.number()),
    category: z.string().min(1, "Category is required"),
    number: z.number().min(1, "Number is required"),
    code: z.string().min(1, "Code is required"),
    title: z.string().min(1, "title is required"),
    description: z.string().min(1, "description is required"),
    created: dateString,
    createdBy: z.string().email("Created By must be a valid email"),
    modified: dateString,
    modifiedBy: z.string().email("Modified By must be a valid email"),
});

export const AircraftTypeSchemaUpdate = AircraftTypeSchema.extend({
    id: z.number().min(1, "ID is required")
});

